import { render, staticRenderFns } from "./InvoiceBar.vue?vue&type=template&id=31d1c2a2&"
import script from "./InvoiceBar.vue?vue&type=script&lang=js&"
export * from "./InvoiceBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports